// Tela do menu "Integração" (permissão de empresa "ATIVAR INTEGRAÇÃO PAGAMENTOS").
// PROPOSITALMENTE VAZIA por enquanto: só o título, sem nenhum conteúdo ou chamada de API.
// Aqui vão entrar depois as credenciais do gateway de pagamento do cliente.
// O gate de acesso fica em auth.tsx (isIntegracaoPagamentosDisponivel), usado pelo menu e pela rota.
export default function Integracao() {
  return (
    <div>
      <div className="titulo-pg">
        <h1>Integração</h1>
      </div>
    </div>
  );
}
